// Shared constants for the Cancel Order flow.
// Kept in a separate file so Fast Refresh works when the components in this
// folder re-render (components-only files is the rule).
import type { CancellationReason } from '../../../auth/services/auth-api'

export const CANCEL_NOTE_MAX_LENGTH = 500

// Order mirrors the mock's CANCEL_REASONS (lib/order-cancellation.ts:15-22).
export const CANCEL_REASONS: { value: CancellationReason; label: string }[] = [
  { value: 'no_longer_needed', label: 'No longer needed' },
  { value: 'wrong_item', label: 'Ordered the wrong item' },
  { value: 'got_elsewhere', label: 'Got it elsewhere' },
  { value: 'job_moved', label: 'Job cancelled or moved' },
  { value: 'other', label: 'Other' },
]
